import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "medium24",
  standalone: true,
})
export class Medium24Pipe implements PipeTransform {
  transform(value: any): any {
    if (!value) return value;

    const date = new Date(value);
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's timezone
    };

    return new Intl.DateTimeFormat("default", options).format(date);
  }
}
